<template>
  <div class="c-order-card" :class="orderInfo.repurchaseFlag && type === 'b' && 'has-tag'" >
    <div v-if="orderInfo" class="card-content">
      <div v-if="orderInfo.repurchaseFlag && type === 'b'" class="repay-tag">
        回購訂單
      </div>
      <div class="card-header">
        <div class="card-id">
          <p>{{ new Date(orderInfo.createTime).$format('yyyy-MM-dd hh:mm:ss') }}</p>
        </div>
        <div class="card-time" @click="toOrderDetail">
          <img src="~@/assets/images/order-detail.png" alt="" />
          <p>訂單詳情</p>
        </div>
      </div>
      <div class="card-msg" :class="showStatus ? 'border-bottom' : null">
        <div class="user-avatar-wrap">
          <fps-avatar
            class="avatar"
            :src="type === 'c' ? orderInfo.playerUserAvatar : orderInfo.userAvatarUrl"
            @click.native.stop="jumpMasterDetail"
          />
        </div>
        <div class="order-info" @click="toOrderDetail">
          <div class="order-msg">
            <p>
              {{
                type === 'c'
                  ? orderInfo.playerUserNickname
                  : orderInfo.userNickname
              }}
            </p>
            <p>
              {{ orderInfo.orderItemVoList[0].playerSkillName }}
              <span v-if="['HalfHour','Minutes7'].includes(orderInfo.orderItemVoList[0].salesUnit)">({{orderInfo.orderItemVoList[0].salesUnit | salesUnitTranslate}}*{{orderInfo.orderItemVoList[0].count}})</span>
              <span v-else>({{orderInfo.orderItemVoList[0].count}}{{orderInfo.orderItemVoList[0].salesUnit | salesUnitTranslate}})</span>
              <span class="give-away-info" v-if="orderInfo.giveAwayInfo">
                贈{{ orderInfo.giveAwayInfo.giftNum }}</span
              >
              <span v-if="orderInfo.quickMatchRandom">🎲</span>
            </p>
          </div>
          <div class="order-price">
            <div class="total-amount" v-if="type === 'b'">
              總價： {{ orderInfo.currencyKind }}{{ orderInfo.originalAmount }}
            </div>
            <!-- <div v-if="type==='c' && orderInfo.discountedAmount !==0">紅包/餘額抵扣： -{{orderInfo.currencyKind}}{{orderInfo.discountedAmount}}</div> -->
            <div
              class="current-amount"
              v-if="orderInfo.status !== 'Created' && type === 'c'"
            >
              實付：{{ orderInfo.currencyKind }}{{ orderInfo.currentAmount }}
            </div>
            <!-- <div v-show="type==='b'">{{orderInfo.currentAmount}}{{orderInfo.currencyKind}}</div> -->
          </div>
          <div :class="['order-status', orderStatusInfo.class]">
            <p>
              {{
                orderInfo.status
                  | orderStatusTranslateUpperCase(type, orderInfo.refundType)
              }}
            </p>
            <p class="order-countDown" v-show="countDownText">
              {{ countDownText }}
            </p>
          </div>
          <div class="order-operation">
            <div
              v-if="showConfirmButton"
              class="review operation-btn red-btn"
              @click.stop="completeOrder(orderInfo.orderNo)"
            >
              確認完成
            </div>
            <div
              v-if="orderInfo.status === 'Created'"
              class="review operation-btn"
              @click.stop="cancelPaying(orderInfo.orderNo)"
            >
              取消訂單
            </div>
            <div
              v-if="orderInfo.status === 'Processing' && type === 'b'"
              class="review operation-btn"
              @click.stop="refoundOrder(orderInfo.orderNo)"
            >
              訂單退款
            </div>
            <div
              v-if="refoundDetailShowBtn"
              class="review operation-btn"
              @click.stop="checkControversy"
            >
              退款詳情
            </div>
            <div
              v-if="showConfirmButton && type === 'c'"
              class="review operation-btn"
              @click.stop="corderRefound"
            >
              退款
            </div>
            <div
              v-if="type === 'c' && orderInfo.status === 'Completed'"
              class="review operation-btn"
              @click.stop="writeReview(orderInfo)"
            >
              寫評價
            </div>
            <div
              v-if="
                type === 'b' &&
                orderInfo.playerCommentStatus === 'NotComment' &&
                (orderInfo.status === 'Completed' ||
                  orderInfo.status === 'Finished')
              "
              class="review operation-btn"
              @click.stop="writeReviewToNormal(orderInfo)"
            >
              評價
            </div>
            <div
              v-if="
                orderInfo.buyerCommentStatus !== 'NotComment' ||
                (type === 'b' && orderInfo.playerCommentStatus !== 'NotComment')
              "
              class="ckeck-review operation-btn"
              @click.stop="checkReview(orderInfo.orderNo)"
            >
              <i v-if="isGettingOrderDetail" class="el-icon-loading" />
              <template v-else>查看評價</template>
            </div>
            <div
              v-if="
                type === 'c' &&
                orderInfo.status === 'Arbitration' &&
                orderInfo.status === 'Arbitrating' &&
                orderInfo.status === 'Arbitrated'
              "
              class="review operation-btn"
              @click.stop="openChat('service')"
            >
              聯繫客服
            </div>
            <div
              v-if="type === 'b' && orderInfo.status === 'Effective'"
              class="review operation-btn"
              @click.stop="acceptOrder(orderInfo.orderNo)"
            >
              立即接單
            </div>
            <div
              v-if="
                type === 'c' &&
                (orderInfo.status === 'Completed' ||
                  orderInfo.status === 'Finished')
              "
              class="review operation-btn re-pay"
              @click.stop="rePay(orderInfo.orderItemVoList[0])"
            >
              再來一單
            </div>
          </div>
        </div>
      </div>
      <div class="production-info" v-if="showCardFooter">
        <div class="production-left">
          <img
            src="~@/assets/images/time-clock.png"
            v-show="countDownText"
            alt=""
          />
          <p class="order-countDown" v-show="countDownText">
            {{ countDownText }}
          </p>
        </div>
        <div class="order-operation-auto">
          <div
            v-if="showConfirmButton"
            class="review operation-btn red-btn"
            @click.stop="completeOrder(orderInfo.orderNo)"
          >
            確認完成
          </div>
          <div
            v-if="orderInfo.status === 'Created'"
            class="review operation-btn"
            @click.stop="cancelPaying(orderInfo.orderNo)"
          >
            取消訂單
          </div>
          <div
            v-if="orderInfo.status === 'Processing' && type === 'b'"
            class="review operation-btn"
            @click.stop="refoundOrder(orderInfo.orderNo)"
          >
            訂單退款
          </div>
          <div
            v-if="orderInfo.status === 'Controversy'"
            class="review operation-btn"
            @click.stop="checkControversy"
          >
            查看詳情
          </div>
          <div
            v-if="refoundDetailShowBtn"
            class="review operation-btn"
            @click.stop="checkControversy"
          >
            退款詳情
          </div>
          <div
            v-if="type === 'c' && orderInfo.status === 'Completed'"
            class="review operation-btn"
            @click.stop="writeReview(orderInfo)"
          >
            寫評價
          </div>
          <div
            v-if="
              type === 'b' &&
              orderInfo.playerCommentStatus === 'NotComment' &&
              (orderInfo.status === 'Completed' ||
                orderInfo.status === 'Finished')
            "
            class="review operation-btn"
            @click.stop="writeReviewToNormal(orderInfo)"
          >
            評價
          </div>
          <div
            v-if="
              orderInfo.buyerCommentStatus !== 'NotComment' ||
              (type === 'b' && orderInfo.playerCommentStatus !== 'NotComment')
            "
            class="ckeck-review operation-btn"
            @click.stop="checkReview(orderInfo.orderNo)"
          >
            <i v-if="isGettingOrderDetail" class="el-icon-loading" />
            <template v-else>查看評價</template>
          </div>
          <div
            v-if="type === 'b' && orderInfo.status === 'Effective'"
            class="review operation-btn"
            @click.stop="acceptOrder(orderInfo.orderNo)"
          >
            立即接單
          </div>
          <div
            v-if="
              type === 'c' &&
              (orderInfo.status === 'Completed' ||
                orderInfo.status === 'Finished')
            "
            class="review operation-btn re-pay"
            @click.stop="rePay(orderInfo.orderItemVoList[0])"
          >
            再來一單
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      class="controversy-dialog"
      :close-on-click-modal="moderl"
      :visible.sync="controversyDialog"
      width="418px"
      title="申請退款詳情"
    >
      <div class="controversy-top">
        <div class="top-point"></div>
        <p>{{ orderInfo.userNickname }}</p>
        <p>發起申請退款</p>
      </div>
      <div class="controversy-middle">
        <div class="controversy-time"></div>
        <div class="controversy-description">
          申訴理由：{{
            orderInfo.cancelReason ? orderInfo.cancelReason : controversyText
          }}
        </div>
      </div>
      <div class="controversy-bottom">
        <div class="bottom-point"></div>
        <p>
          {{
            type === 'c'
              ? '等待陪玩師處理您的取消訂單申請'
              : '等待您處對方的取消訂單申請'
          }}
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-show="type === 'c'"
          type="primary"
          @click="controversyDialog = false"
          >知道了</el-button
        >
        <el-button
          v-show="type === 'b'"
          @click="rejectControversy(orderInfo.orderNo)"
          >拒絕</el-button
        >
        <el-button
          v-show="type === 'b'"
          @click="confrimControversy(orderInfo.orderNo)"
          type="primary"
          >同意</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      class="controversy-dialog-auto"
      :close-on-click-modal="moderl"
      :visible.sync="controversyDialog"
      width="418px"
      title="此功能僅限於在行動版或電腦端使用"
    >
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="controversyDialog = false"
          >知道了</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      class="write-controversy-dialog"
      :visible.sync="writeControversyDialog"
      width="418px"
      title="填寫申請退款理由"
    >
      <el-input
        v-model="controversyText"
        type="textarea"
        rows="6"
        maxlength="200"
        height="150px"
        placeholder="請輸入申請退款理由"
        @click.native.stop
      />
      <span slot="footer" class="dialog-footer">
        <el-button
          :disabled="!controversyText"
          @click="submitControversy(orderInfo.orderNo)"
          type="primary"
          >提交</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="reviewDialog"
      :append-to-body="true"
      :class="[
        'write-review-dialog',
        starLevel && 'select-star',
        (textAreaFocus || reviewText) && 'heighter',
        isUpdatingComment && 'update-comment',
      ]"
      width="418px"
      :center="true"
      title="評價陪玩師"
      @close="autoUpdateComment"
    >
      <p v-show="isUpdatingComment" class="star-tips">
        注：評價的星數不可低於原有評價喔，且每人只有一次修改評價的機會喔
      </p>
      <div v-show="!isUpdatingComment && starLevel && starLevel !== 5" class="first-star-tips">
        <div>
          注：首次完成評價後<span>48小時內可修改評價</span>，評價的星數不可低於原有評價，且每條評價只可修改一次喔~
        </div>
      </div>
      <div class="review-dialog-header" :style="{ marginTop: starLevel && '10px' }">
        <!-- <p>技能評價</p> -->
        <div class="stars">
          <span
            v-for="index in 5"
            :key="index"
            @click="selectStarLevel(index)"
            class="star-item pointer"
          >
            <fps-icon :class="['star-icon', starLevel && index <= starLevel && 'checked']" type="star1" />
          </span>
        </div>
      </div>
      <div v-show="!starLevel" class="no-score">輕點評分</div>
      <div v-show="starLevel" class="comment-score">
        {{ starLevel | startText }}
      </div>
      <div v-show="starLevel" class="comment-textarea">
        <el-input
          @click.native.stop
          v-model="reviewText"
          type="textarea"
          maxlength="200"
          class="textarea"
          resize="none"
          :placeholder="
            starLevel === 5
              ? '請輸入詳細評價，幫他增加曝光吧～'
              : '請輸入文字評價，幫助陪玩師改進'
          "
          @focus="focusChange(true)"
          @blur="focusChange(false)"
        />
        <div class="text-count">{{ reviewText.length }}/200</div>
      </div>
      <transition name="fade">
        <div v-show="showTags" class="tags-wrap">
          <div class="title">添加標籤（最多3個）</div>
          <ul>
            <li
              v-for="item in commentTags"
              :key="item.id"
              :class="{ 'active': item.choose }"
              @click="tagsClick(item)"
            >{{ item.tag }}</li>
          </ul>
        </div>
      </transition>
      <div v-show="starLevel" class="anonymous">
        <div
          class="pointer"
          @click="isUpdatingComment ? '' : (anonymous = !anonymous)"
        >
          <img
            v-show="!anonymous"
            src="~@/assets/image/icons/radio-normal.png"
          />
          <img
            v-show="anonymous"
            src="~@/assets/image/icons/radio-active.png"
          />
          <span>匿名評價</span>
        </div>
      </div>
      <span v-show="starLevel" slot="footer" class="dialog-footer">
        <el-button
          @click="submitReview(orderInfo)"
          type="primary"
          :disabled="
            !reviewText &&
            (isUpdatingComment
              ? starLevel === orderDetail.orderCommentVo.starRating
              : starLevel < 5)
          "
          >提交評價</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="checkReviewDialog"
      custom-class="dialog-clear-style comments-dialog"
      append-to-body
      :show-close="false"
      top="0"
      width="100vw"
    >
      <div class="dialog-wrap">
        <div class="page-title">
          <h3>查看評價</h3>
          <fps-icon class="close-icon" type="close" @click.native="checkReviewDialog = false" />
        </div>
        <div class="page-main">
          <!-- C端評價 -->
          <div v-if="orderCommentVo" class="normal-comment comment-box">
            <img
              class="avatar"
              :src="orderCommentVo.commentatorAvatarUrl + '?d=600x600'"
            />
            <div class="comment-detail">
              <div class="title">
                <template v-if="type === 'b'">
                  <p>{{ orderCommentVo.commentatorName }}</p>
                  <span> 評價了你</span>
                </template>
                <template v-else-if="type === 'c'">
                  <span>你評價了陪玩師</span>
                </template>
              </div>
              <div class="comment-time">
                {{ new Date(orderCommentVo.createTime).$format('yyyy-MM-dd hh:mm') }}
              </div>
              <div class="comment-star">
                <fps-star :count="orderCommentVo.starRating" />
                <p>{{ orderCommentVo.starRating }}分</p>
              </div>
              <div v-if="orderCommentVo.content" class="comment-content">
                {{ orderCommentVo.content }}
              </div>
              <div v-if="orderCommentVo.tags && orderCommentVo.tags.length" class="content-tags">
                <div>{{ orderCommentVo.tags.map(tag => tag.tag).join('，') }}</div>
              </div>
            </div>
            <div
              v-show="
                type === 'c' &&
                orderInfo.buyerCommentStatus === 'BuyerCommented'
              "
              class="fix-comment pointer"
              @click.stop="updateReview"
            >
              <i v-if="isEdittingOrderDetail" class="el-icon-loading" />
              <template v-else>
                <fps-icon class="edit-icon" type="edit1" />修改評價
              </template>
            </div>
          </div>
          <!-- B端評價 -->
          <div
            v-if="playerCommentVo && type === 'b'"
            class="player-comment comment-box"
          >
            <img class="avatar" :src="userInfo.avatarUrl + '?d=600x600'" />
            <div class="comment-detail">
              <div class="title">
                <template v-if="type === 'c'">
                  <p>{{ playerCommentVo.playerNickname }}</p>
                  <span>評價了你</span>
                </template>
                <span v-if="type === 'b'"
                  >你評價了 {{ orderInfo.userNickname }}</span
                >
              </div>
              <div class="comment-time">
                {{ new Date(playerCommentVo.createTime).$format('yyyy-MM-dd hh:mm') }}
              </div>
              <div class="comment-like">
                <img
                  :src="
                    playerCommentVo.tagKind === 'DISLIKE'
                      ? checkedDislikeIcon
                      : checkedLikeIcon
                  "
                />
                <p>
                  {{
                    playerCommentVo.tagKind === 'DISLIKE' ? '不喜歡' : '喜歡'
                  }}
                </p>
              </div>
              <div v-if="playerCommentVo.tag" class="comment-tag">
                <span v-for="tag in playerCommentVo.tag.split(',')" :key="tag"
                  >#{{ tag }}</span
                >
              </div>
              <div v-if="playerCommentVo.content" class="comment-content">
                {{ playerCommentVo.content }}
              </div>
            </div>
          </div>
        </div>
        <div class="page-footer">
          <button @click="checkReviewDialog = false">確定</button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      class="reject-controversy-dialog"
      :visible.sync="rejectcontroversydialog"
      width="418px"
      title="拒絕退款理由"
    >
      <el-input
        v-model="rejectControversyText"
        type="textarea"
        rows="6"
        maxlength="200"
        height="150px"
        placeholder="請輸入拒絕退款理由"
      />
      <span slot="footer" class="dialog-footer">
        <el-button
          :disabled="!rejectControversyText"
          @click="confrimRejectControversy(orderInfo.orderNo)"
          type="primary"
          >提交</el-button
        >
      </span>
    </el-dialog>
    <FloatDialog :firstOrder="firstOrder" :inviterUuid="inviterUuid" />
    <el-dialog
      :visible.sync="reviewDialogToNormalVisible"
      append-to-body
      width="100vw"
      top="0"
      :show-close="false"
      custom-class="dialog-clear-style write-comment-to-normal"
      :before-close="beforeCloseWriteComment"
      @open="getCommentTagList"
    >
      <div class="dialog-wrap">
        <div class="page-title">
          <h3>評價</h3>
          <fps-icon class="close-icon" type="close" @click.native="beforeCloseWriteComment()" />
        </div>
        <div class="page-main">
          <div class="title">
            <h3>您對這位用戶的感受如何？</h3>
            <span>已匿名</span>
          </div>
          <div v-if="orderInfo" class="order-info">
            <img
              class="player-avatar"
              :src="orderInfo.userAvatarUrl + '?d=600x600'"
              border-radius="100%"
            />
            <div class="order-player-info">
              <p>{{ orderInfo.userNickname }}</p>
              <p>
                <span>{{ orderInfo.orderItemVoList[0].gameName }}</span>
                <span>{{ new Date(orderInfo.createTime).$format('hh:mm, yyyy-MM-dd') }}</span>
              </p>
            </div>
          </div>
          <div v-if="tagsMap" class="order-comment">
            <div class="result">
              <div
                :class="{
                  checked: commentIntention === 'DISLIKE',
                }"
                @click="commentIntention = 'DISLIKE'"
              >
                <img
                  :src="
                    commentIntention === 'DISLIKE'
                      ? checkedDislikeIcon
                      : dislikeIcon
                  "
                  alt=""
                />
                <span>不喜歡</span>
              </div>
              <div
                :class="{
                  checked: commentIntention === 'LIKE',
                }"
                @click="commentIntention = 'LIKE'"
              >
                <img
                  :src="
                    commentIntention === 'LIKE' ? checkedLikeIcon : likeIcon
                  "
                  alt=""
                />
                <span>喜歡</span>
              </div>
            </div>
            <div v-if="commentIntention" class="tags">
              <p>請選擇原因，幫助平台維持健康生態</p>
              <div class="tag-list">
                <div
                  v-for="(tag, index) in tagsMap[commentIntention]"
                  :key="index"
                  :class="{
                    checked:
                      checkedTags.findIndex((item) => item.tag === tag.tag) >
                      -1,
                  }"
                  @click="toggleCommentTag(tag)"
                >
                  <span>{{ tag.tag }}</span>
                </div>
                <div
                  v-if="commentIntention === 'LIKE'"
                  @click="toggleCommentTag()"
                >
                  <img src="~@/assets/image/fps-icon/edit-icon.png" alt="" />
                  <span>寫評價</span>
                </div>
              </div>
              <textarea
                v-show="
                  customInputTextareaVisible || commentIntention === 'DISLIKE'
                "
                v-model.trim="customInputTextareaText"
                placeholder="您的反饋會讓我們做的更好（不超過200字）"
                @input="validateTextareaLen"
              />
            </div>
          </div>
        </div>
        <div class="page-footer">
          <p>評價不會顯示給其他用戶，僅為數據收集</p>
          <button
            :disabled="submitBtnDisabled ? 'disabled' : false"
            @click="submitComment"
          >
            <i v-if="isSubmitingComment" class="el-icon-loading" />
            <template v-else>提交評價</template>
          </button>
        </div>
      </div>
    </el-dialog>
    <DialogAfterComment
      v-model="showGiftAfterComment"
      :orderInfo="orderInfo"
      :giftInfo="commentGiftInfo"
      :selectedGiftCount="selectedGiftCount"
    />
    <OrderCancel :orderCancelShow="orderCancelShow" :orderInfo="orderInfo" @closeDialog="handleCloseDialog"></OrderCancel>
    <el-dialog
      custom-class="corder-round"
      :visible.sync="corderRoundVisible"
      width="375px"
      :append-to-body="true"
    >
      <div class="corder-round-title" slot="title">
        <span>{{ corderRoundTitle | formatRoundTitle }}</span>
        <fps-icon
          v-show="corderRoundTitle === 'orderRound'"
          size="16"
          color="#8C94AA"
          type="question-o"
          @click.native="handleRoundExplain('refoundExplain')"
        />
        <fps-icon
          v-show="corderRoundTitle === 'borderRound'"
          size="16"
          color="#8C94AA"
          type="question-o"
          @click.native="handleRoundExplain('brefoundExplain')"
        />
      </div>
      <cOrderRound
        v-show="corderRoundTitle === 'orderRound'"
        :orderInfo="refoundOrderInfo"
        :userInfo="userInfo"
        :dialogloading="dialogloading"
        @handleRoundExplain="handleRoundExplain"
      />
      <bOrderRound
        v-show="corderRoundTitle === 'borderRound'"
        :orderInfo="refoundOrderInfo"
        :userInfo="userInfo"
        :dialogloading="dialogloading"
        @handleRoundExplain="handleRoundExplain"
      />
      <c-refound-detai
        v-show="corderRoundTitle === 'orderRoundDetail'"
        :dialogloading="dialogloading"
        :refoundInfo="refoundInfo"
      ></c-refound-detai>
      <b-refound-detai
        v-show="corderRoundTitle === 'borderRoundDetail'"
        :dialogloading="dialogloading"
        :refoundInfo="refoundInfo"
        @getRefoundDetail="getRefoundDetail"
        @goToRefuseRefound="goToRefuseRefound"
        @gobRefound="gobRefound"
      ></b-refound-detai>
      <refuse-refound
        v-show="corderRoundTitle === 'refuseRefound'"
        :dialogloading="dialogloading"
        :orderNo="orderInfo.orderNo"
        @goToborderDetail="goToborderDetail"
      ></refuse-refound>
      <oreder-refound-explain
        @handleRoundExplain="handleRoundExplain"
        v-show="corderRoundTitle === 'refoundExplain'"
      />
      <boreder-refound-explain
        @handleRoundExplain="handleRoundExplain"
        v-show="corderRoundTitle === 'brefoundExplain'"
      />
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import FloatDialog from './float-dialog';
import cOrderRound from './c-order-round';
import cRefoundDetai from './c-refound-detai';
import bRefoundDetai from './b-refound-detai';
import orederRefoundExplain from './oreder-refound-explain';
import borederRefoundExplain from './boreder-refound-explain';
import refuseRefound from './refuse-refound';
import DialogAfterComment from './dialog-after-comment';
import OrderCancel from './order-cancel';
import bOrderRound from './b-order-refound';
import GlobalAmount from '@/components/common/amount/global-amount'
import PraiseFollow from './praise-follow'
import RebateTpl from './rebate-dialog'
const PraiseFollowPopup = GlobalAmount(PraiseFollow)
const RebatePopup = GlobalAmount(RebateTpl)
import {
  acceptOrder,
  isFirstOrder,
  completeOrder,
  controversyOrder,
  reviewOrder,
  rejectControversy,
  confrimControversy,
  orderDetail,
  getCommentTags,
  createCommentToNormal,
  bCompleteOrder,
} from './order';
export default {
  filters: {
    startText(startCount) {
      switch (startCount) {
        case 1: {
          return '1分，很不滿意';
        }
        case 2: {
          return '2分，不太滿意';
        }
        case 3: {
          return '3分，一般';
        }
        case 4: {
          return '4分，還不錯';
        }
        case 5: {
          return '5分，非常棒';
        }
        default: {
          return '';
        }
      }
    },
    formatRoundTitle(corderRoundTitle) {
      let map = {
        orderRound: '申請退款',
        borderRound: '申請退款',
        refoundExplain: '訂單退款說明',
        brefoundExplain: '訂單退款',
        orderRoundDetail: '退款詳情',
        borderRoundDetail: '退款詳情',
        refuseRefound: '拒絕說明',
      };
      return map[corderRoundTitle] || '';
    },
  },
  components: {
    DialogAfterComment,
    FloatDialog,
    OrderCancel,
    bOrderRound,
    cOrderRound,
    orederRefoundExplain,
    borederRefoundExplain,
    cRefoundDetai,
    bRefoundDetai,
    refuseRefound,
  },
  props: {
    type: String,
    index: {
      type: Number,
      default: 0,
    },
    orderInfo: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      /* c端退款 start */
      refoundInfo: {},
      refoundOrderInfo: {},
      dialogloading: true,
      corderRoundTitle: 'orderRound',
      corderRoundVisible: false,
      /* c端退款 end */
      selectedGiftCount: 0,
      showGiftAfterComment: false,
      textAreaFocus: false,
      orderDetail: null,
      isUpdatingComment: false,
      playerCommentVo: null,
      orderCommentVo: null,
      isGettingOrderDetail: false,
      isEdittingOrderDetail: false,
      isSubmitingComment: false,
      checkedDislikeIcon: require('@/assets/images/checked-dislike-icon.png'),
      dislikeIcon: require('@/assets/images/dislike-icon.png'),
      checkedLikeIcon: require('@/assets/images/checked-like-icon.png'),
      likeIcon: require('@/assets/images/like-icon.png'),
      tagsMap: null,
      pageLoaded: false,
      commentIntention: null,
      checkedTags: [],
      customInputTextareaVisible: false,
      customInputTextareaText: '',
      timer: null,
      commentext: '',
      commentRating: 5,
      starLevel: 0,
      moderl: false,
      reviewText: '',
      controversyText: '',
      firstOrder: false,
      inviterUuid: '',
      rejectControversyText: '',
      reviewDialog: false,
      reviewDialogToNormalVisible: false,
      checkReviewDialog: false,
      controversyDialog: false,
      writeControversyDialog: false,
      rejectcontroversydialog: false,
      uuid: '',
      currentRotate: 0,
      showStatus: false,
      countDownText: '',
      stepOk: require('@/assets/imgs/step-already.png'),
      step2Img: require('@/assets/imgs/icon-step2-on.png'),
      step3Img: require('@/assets/imgs/icon-step3-on.png'),
      step4Img: require('@/assets/imgs/icon-step4-on.png'),
      step5Img: require('@/assets/imgs/icon-step5-on.png'),
      step2OffImg: require('@/assets/imgs/icon-step2-off.png'),
      step3OffImg: require('@/assets/imgs/icon-step3-off.png'),
      step4OffImg: require('@/assets/imgs/icon-step4-off.png'),
      step5OffImg: require('@/assets/imgs/icon-step5-off.png'),
      anonymous: false,
      orderCancelShow: false,
      orderRefoundShow: false,
      detailShow: false, //退款詳情
      commentTags: [],
      choiceTags: [],
      rebate: 0
    };
  },
  created() {
    this.$store.dispatch('order/getGiftInfo');
    this.orderStatus = this.orderInfo.status;
    this.setIntervalTimer(this.orderInfo);
  },
  mounted() {
    const paramsStr = window.sessionStorage.getItem('GIFT_AFTER_COMMENT');
    if (paramsStr) {
      const { isCommentSendGift, orderInfo, giftCount } = JSON.parse(paramsStr);
      if (isCommentSendGift && this.orderInfo.orderNo === orderInfo.orderNo) {
        this.showGiftAfterComment = true;
        this.selectedGiftCount = giftCount;
        window.sessionStorage.removeItem('GIFT_AFTER_COMMENT');
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'commentGiftInfo']),
    orderAvatar() {
      return this.type === 'c' ? this.orderInfo.playerUserAvatar : this.orderInfo.userAvatarUrl
    },
    showCardFooter() {
      if (
        (this.orderInfo.status === 'Negotiate' && this.type === 'b') ||
        (this.orderInfo.status === 'Processing' && this.type === 'b') ||
        (this.type === 'b' && this.orderInfo.status === 'Completed') ||
        this.orderInfo.status === 'Created' ||
        this.orderInfo.status === 'Invalid'
      ) {
        return false;
      } else {
        return true;
      }
    },
    refoundDetailShowBtn() {
      let map = ['REFUND_SUCCESS', 'Controversy', 'Negotiate'];
       let tui_success=(this.orderInfo.status === 'Invalid'&&this.orderInfo.refundType === 'FULL')
      return (map.indexOf(this.orderInfo.status) !== -1)||tui_success;
    },
    orderStatusInfo() {
      let status
      // switch (this.orderInfo.status) {
      //   case 'Created':
      //   case 'Effective':
      //   case 'Processing':
      //   case 'Controversy':
      //   case 'Negotiate':
      //   case 'Arbitration':
      //   case 'Arbitrated':
      //   case 'Arbitrating':
      //   case 'Completed':
      //     status = {
      //       class: 'color-red',
      //     };
      // }
      if (['Created', 'Effective', 'Processing', 'Controversy', 'Negotiate', 'Arbitration', 'Arbitrated', 'Arbitrating', 'Completed'].includes(this.orderInfo.status)) {
        status = {
          class: 'color-light',
        }
      }

      return status || { class: '' };
    },
    activeStep() {
      let step;
      switch (this.orderInfo.status) {
        case 'Created':
          step = 1;
          break;
        case 'Effective':
          step = 2;
          break;
        case 'Processing':
        case 'Controversy':
        case 'Negotiate':
        case 'Arbitration':
        case 'Arbitrated':
        case 'Arbitrating':
          step = 3;
          break;
        case 'Completed':
          step = 5;
          break;
        case 'Finished':
          step = 6;
          break;
        case 'Invalid':
          if (this.orderInfo.orderRecordList.length < 4) {
            step = 2;
          } else {
            step = 3;
          }
      }
      return step;
    },
    submitBtnDisabled() {
      const { commentIntention, checkedTags, customInputTextareaText } = this;

      return (
        !commentIntention ||
        (commentIntention === 'DISLIKE' &&
          !checkedTags.length &&
          !customInputTextareaText)
      );
    },
    showConfirmButton() {
      let isCshow =
        this.type === 'c' && this.orderInfo.status === 'PlayerConfirm';
      return this.orderInfo.status === 'Processing' || isCshow;
    },
    showTags() {
      if (this.isUpdatingComment) return false
      return this.starLevel == 5;
    },
  },
  watch: {
    corderRoundTitle(newValue) {
      if (newValue === 'orderRoundDetail' || newValue === 'borderRoundDetail') {
        this.getRefoundDetail();
      }
    },
    corderRoundVisible(newValue) {
      if (newValue) {
        if (
          this.corderRoundTitle === 'orderRound' ||
          this.corderRoundTitle === 'borderRound'
        ) {
          this.getOrderDetail();
        }
      } else {
        this.$emit('getOrderList', this.type);
        this.dialogloading = true;
        this.handleRoundExplain('orderRound');
      }
    },
    orderInfo: {
      handler(newVal) {
        this.setIntervalTimer(newVal);
      },
      deep: true,
    },
    reviewDialog(newVal) {
      if (!newVal) {
        let orderNo = this.orderInfo.orderNo;
        isFirstOrder({
          uuid: orderNo,
        }).then(({ data }) => {
          if (data.display) {
            this.firstOrder = true;
            this.inviterUuid = data.inviterUuid;
          } else if (this.afterReviewCallback) {
            this.afterReviewCallback();
            this.afterReviewCallback = null;
          }
        });
      }
    },
    commentIntention() {
      this.checkedTags = [];
      this.customInputTextareaVisible = false;
    },
    customInputTextareaVisible(val) {
      if (!val) this.customInputTextareaText = '';
    },
    reviewDialogToNormalVisible(val) {
      if (!val) {
        this.customInputTextareaText = '';
        this.commentIntention = '';
        this.checkedTags = [];
      }
    },
    starLevel(newVal) {
      if (newVal == 5) {
        this.getCommentTags();
      }
    },
  },
  methods: {
    rebateOpen() {
      return new Promise((resolve)=>{
        if(this.rebate <= 0) {
          resolve()
          return
        }
        RebatePopup({
          props: {
            rebate: this.rebate
          },
          on: {
            close: ()=> {
              this.rebate = 0
              resolve()
            }
          }
        })
      })
    },
    handleCloseDialog() {
      this.orderCancelShow = false
    },
    // 繼續退款
    gobRefound(title) {
      this.handleRoundExplain(title);
      this.getOrderDetail();
    },
    goToborderDetail(title) {
      this.handleRoundExplain(title);
    },
    // 拒絕退款彈窗
    goToRefuseRefound(title) {
      this.handleRoundExplain(title);
    },
    // 退款詳情 獲取退款信息
    getRefoundDetail() {
      this.dialogloading = true;
      this.$http
        .post('/tradeRefund/getRefundDetail', {
          orderNo: this.orderInfo.orderNo,
        })
        .then(({ data }) => {
          this.refoundInfo = data || {};
          this.dialogloading = false;
        })
        .catch((err) => {
          console.log(err);
          this.dialogloading = false;
        });
    },
    // 退款申請 獲取訂單詳情
    getOrderDetail() {
      this.dialogloading = true;
      orderDetail({
        orderNo: this.orderInfo.orderNo,
      })
        .then(({ data, msg }) => {
          if (data) {
            this.refoundOrderInfo = data;
          } else {
            this.$message.error(msg);
          }
          this.pageLoaded = true;
          this.dialogloading = false;
        })
        .catch((err) => {
          console.log(err);
          this.dialogloading = false;
        });
    },
    // 退款申請，退款说明，退款詳情
    handleRoundExplain(title) {
      this.corderRoundTitle = title;
    },
    handleCloseRound() {
      this.corderRoundVisible = false;
    },
    // c端退款申請
    corderRefound() {
      this.$confirm(
        {
          content: '發起退款後需填寫退款理由，並獲得陪玩師同意後才可取消訂單。如意見不一致，可聯繫客服處理。',
          title: '確認申請退款嗎？',
          confirmButtonText: '確認申請',
          cancelButtonText: '再想想',
          closeOnClickModal: true,
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          this.corderRoundVisible = true;
        })
        .catch(() => {});
    },
    focusChange(flag) {
      this.textAreaFocus = flag;
    },
    getCommentTags() {
      if (!this.commentTags.length) {
        this.$http.post('/comment/tag/listV2', {
          gameId: this.orderInfo.orderItemVoList[0].gameId
        }).then(({ data }) => {
          this.commentTags = data.COMMENTATOR.map(item => {
            return {
              ...item,
              choose: false
            }
          })
          this.choiceTags = []
        })
      }
    },
    toOrderDetail() {
      this.$emit('detail', this.orderInfo.orderNo, this.type);
    },
    openChat(type = 'user') {
      if (type === 'user') {
        // 與用戶的會話
        const {
          type,
          orderInfo: { userUuid, playerUserUuid },
        } = this;

        this.$util.openChatWindow(
          this.userInfo.uuid,
          type === 'b' ? userUuid : playerUserUuid
        );
      } else {
        this.$util.openChatWindow(
          this.userInfo.uuid
        );
      }
    },
    /**
     * @description 跳轉大神詳情
     */
    jumpMasterDetail() {
      const params = {
        uuid:
          this.type === 'c'
            ? this.orderInfo.playerUserUuid
            : this.orderInfo.userUuid,
      };

      if (this.type === 'c') {
        params.skill = this.orderInfo.orderItemVoList[0].playerSkillId;
      }

      this.$router.push({
        name: 'playerDetail',
        params,
      });
    },
    /**
     * @description: 提示用户追踪好评用户
     * @param {*}
     * @return {*}
     */
    popupFollow() {
      return new Promise((resolve)=>{
        PraiseFollowPopup({
          props: {
            orderInfo: this.orderInfo,
            orderAvatar: this.orderAvatar
          },
          on: {
            close: ()=>{
              resolve(true)
            }
          }
        })
      })
    },
    checkReview(orderNo) {
      if (this.isGettingOrderDetail) return;
      this.isGettingOrderDetail = true;

      orderDetail({ orderNo: orderNo })
        .then((data) => {
          this.isGettingOrderDetail = false;

          this.orderCommentVo = data.data.orderCommentVo;

          // if (this.type === 'b') {
          this.playerCommentVo = data.data.playerCommentVo;
          // }

          this.checkReviewDialog = true;
        })
        .catch(() => {
          this.isGettingOrderDetail = false;
        });
    },

    writeReview() {
      this.isUpdatingComment = false;
      this.reviewDialog = true;
    },
    updateReview() {
      if (this.isEdittingOrderDetail) return;
      const { orderNo } = this.orderInfo;

      this.isEdittingOrderDetail = true;

      orderDetail({ orderNo: orderNo })
        .then(({ data }) => {
          this.isUpdatingComment = true;
          this.reviewText = data.orderCommentVo.content;
          this.starLevel = data.orderCommentVo.starRating;
          this.anonymous = !!data.orderCommentVo.anonymous;
          this.orderDetail = data;
          this.reviewDialog = true;
          this.$nextTick(() => {
            this.checkReviewDialog = false;
          });
        })
        .finally(() => {
          this.isEdittingOrderDetail = false;
        });
    },
    /**
     * @description B端評價C端
     */
    writeReviewToNormal() {
      this.reviewDialogToNormalVisible = !this.reviewDialogToNormalVisible;
    },
    /**
     * 關閉評價dialog時自動修改評價
     */
    autoUpdateComment() {
      // const { orderDetail, isUpdatingComment } = this
      // if (!isUpdatingComment || !orderDetail) return
      // const { orderNo, orderCommentVo } = orderDetail
      // const params = {
      //   orderNo,
      //   content: orderCommentVo.content,
      //   starRating: orderCommentVo.starRating,
      //   modifyComment: true
      // }
      // reviewOrder(params).then(() => {
      //   this.orderInfo.buyerCommentStatus = 'BuyerFinalCommented'
      // })
    },
    async submitReview(orderInfo) {
      const { isUpdatingComment } = this;
      if (isUpdatingComment) {
        this.reviewDialog = false;
        try {
          await this.$confirm({
            content: '只有一次修改評價的機會，確認提交嗎？',
            confirmButtonText: '確認提交',
            cancelButtonText: '再想想',
          });
        } catch (e) {
          this.reviewDialog = true;
          return;
        }
      }
      const params = {
        orderNo: orderInfo.orderNo,
        content: this.reviewText,
        starRating: this.starLevel,
        modifyComment: isUpdatingComment,
        anonymous: this.anonymous ? 1 : 0,
      };
      if (this.showTags && this.choiceTags.length) {
        params.tags = this.commentTags.filter(item => {
          return this.choiceTags.includes(item.id)
        })
      }

      reviewOrder(params)
        .then(() => {
          this.$message({
            type: 'success',
            message: isUpdatingComment ? '修改評論成功' : '提交成功',
          });
          if (this.starLevel === 5) {
            this.popupFollow().then(()=>{
              if (this.afterReviewCallback) return
              this.showGiftAfterComment = true;
            })
          }
          this.reviewDialog = false;
          this.orderInfo.status = 'Finished';
          this.orderInfo.buyerCommentStatus = isUpdatingComment
            ? 'BuyerFinalCommented'
            : 'BuyerCommented';
        })
        .catch((err) => {
          if (err.code === 624) {
            this.$message.error('您輸入的內容可能包含敏感詞彙，請重新輸入');
          }
        });
    },

    /**
     * @description 选择星级
     * @param {Number} level 选择的星级
     */
    selectStarLevel(level) {
      const { isUpdatingComment, orderDetail } = this;
      if (
        isUpdatingComment &&
        orderDetail &&
        orderDetail.orderCommentVo &&
        level < orderDetail.orderCommentVo.starRating
      )
        return;
      this.starLevel = level;
      if (!this.isUpdatingComment) {
        this.anonymous = level !== 5;
      }
    },
    confrimControversy(uuid) {
      confrimControversy({ uuid }).then(() => {
        this.orderInfo.status = 'Invalid';
        this.controversyDialog = false;
      });
    },
    rejectControversy() {
      this.controversyDialog = false;
      this.$confirm(
        {
          content: '確定拒絕退款後，平台方會按需要進行介入仲裁，視仲裁結果七天內定為取消訂單或完成。',
          title: '確認拒絕退款嗎?',
          confirmButtonText: '拒絕退款',
          cancelButtonText: '再想想',
          type: 'warning',
        }
      ).then(() => {
        this.rejectcontroversydialog = true;
      });
    },
    confrimRejectControversy(uuid) {
      rejectControversy({
        uuid,
        rejectReason: this.rejectControversyText,
      }).then(() => {
        this.$message({
          type: 'success',
          message: '提交成功',
        });
        this.rejectcontroversydialog = false;
        this.orderInfo.status = 'Negotiate';
      });
    },
    checkControversy() {
      if (this.type === 'c') {
        this.handleRoundExplain('orderRoundDetail');
      } else {
        this.handleRoundExplain('borderRoundDetail');
      }

      this.corderRoundVisible = true;
    },
    controversyOrder() {
      this.$confirm(
        {
          content: '發起申請後需要填寫申請理由，且需要陪玩師同意後才可取消訂單，如出現意見不一致，可聯繫客服解決喔。',
          title: '確認申請退款嗎?',
          confirmButtonText: '確認發起',
          cancelButtonText: '再想想',
          type: 'warning',
        }
      ).then(() => {
        this.corderRoundVisible = true;
      });
    },
    submitControversy(uuid) {
      controversyOrder({
        uuid,
        cancelReason: this.controversyText,
      }).then(() => {
        this.orderInfo.status = 'Controversy';
        this.$message({
          type: 'success',
          message: '提交成功',
        });
        this.writeControversyDialog = false;
      });
    },
    completeOrder(uuid) {
      if (this.type !== 'c') {
        this.$confirm(
          {
            content: '為避免糾紛產生，請保證訂單已經全部完成再確認喔！確認完成後若用戶沒確認，訂單將在3天內自動完成。完成後訂單不可再進行取消或退款操作。',
            title: '確認完成訂單嗎？',
            confirmButtonText: '確認完成',
            cancelButtonText: '取消',
            closeOnClickModal: true,
            dangerouslyUseHTMLString: true,
          }
        )
          .then(() => {
            bCompleteOrder({ orderNo: uuid }).then(() => {
              this.orderInfo.status = 'PlayerConfirm';
            });
          })
          .catch(() => { });
        return;
      }
      this.$confirm(
        {
          content: '確認完成後，錢款將打入陪玩師帳戶，您無法再發起退款等售後申請，請謹慎操作。',
          title: '確認完成訂單嗎？',
          confirmButtonText: '確認完成',
          cancelButtonText: '取消',
          closeOnClickModal: true,
          dangerouslyUseHTMLString: true,
        }
      )
        .then(() => {
          completeOrder({ uuid }).then(async ({data}) => {
            this.rebate = data.awardAmount
            this.orderInfo.status = 'Completed';
            const duration = 1000;
            await this.rebateOpen()
            setTimeout(() => {
              this.reviewDialog = true;
            }, duration);
            this.$emit('closeOrderDialog');
            this.$message({
              message: '已完成',
              type: 'success',
              duration,
            });
            this.afterReviewCallback = () => {
              this.$store.dispatch(
                'app/showRedbagDialog',
                'IMMEDIATE_DISCOUNT'
              );
            };
          });
        })
        .catch(() => {});
    },
    /**
     * @description 设置接单倒计时
     */
    setIntervalTimer(data = {}) {
      let countDownMinutes = 0;
      let diff = 0;
      clearTimeout(this.timer);
      this.timer = null;

      // 待接單
      if (data.updateTime && data.status === 'Effective') countDownMinutes = 10;
      diff =
        countDownMinutes * 60 * 1000 - (new Date().getTime() - data.updateTime);

      // 待支付-信用卡支付
      if (
        data.paymentMethod === 'LanXinCreditCard' &&
        data.status === 'Created'
      ) {
        countDownMinutes = 30;
        diff =
          countDownMinutes * 60 * 1000 -
          (new Date().getTime() - data.createTime);
      }

      // 待支付-超商支付
      if (
        (data.paymentMethod === 'LanXinSupermarket' ||
          data.paymentMethod === 'LanXinATM') &&
        data.status === 'Created'
      ) {
        countDownMinutes = 48 * 60;
        diff =
          countDownMinutes * 60 * 1000 -
          (new Date().getTime() - data.createTime);
      }

      if (diff <= 0 || !countDownMinutes) {
        // data.status = 'Invalid'
        this.countDownText = '';
        return;
      }

      let seconds = Math.floor((diff % (60 * 1000)) / 1000);
      let minutes = Math.floor((diff % (60 * 60 * 1000)) / (60 * 1000));
      let hours = Math.floor(diff / (1000 * 60 * 60));

      this.countDownText = `${
        hours > 0 ? (hours > 9 ? hours : '0' + hours) + '時' : ''
      }${minutes > 9 ? minutes : '0' + minutes}分${
        seconds > 9 ? seconds : '0' + seconds
      }秒`;

      this.timer = setTimeout(() => {
        this.setIntervalTimer(data);
      }, 1000);
    },
    cancleOrder() {
      this.orderCancelShow = true;
    },
    acceptOrder(uuid) {
      this.$confirm(
        {
          content: '提供高質量陪玩體驗並且收穫有詳細描述的五星好評，可以幫助您獲得更多曝光和訂單喔！',
          title: '確認接下這單?',
          confirmButtonText: '確認接單',
          cancelButtonText: '再想想',
          type: 'warning',
        }
      ).then(() => {
        acceptOrder({ uuid }).then(() => {
          this.orderInfo.status = 'Processing';
          this.$emit('hasAccept', this.orderInfo)
        });
      });
    },
    showHide() {
      this.showStatus = !this.showStatus;
      let dom = document.getElementsByClassName('check-status-icon')[
        this.index
      ];
      this.currentRotate = (this.currentRotate + 180) % 360;
      dom.style.transform = 'rotate(' + this.currentRotate + 'deg)';
    },
    toPay() {
      const id = this.orderInfo.orderItemVoList[0].playerSkillId;
      this.$util.openWindow(
        `/order/check/${id}/${this.orderInfo.orderItemVoList[0].count}?orderNo=${this.orderInfo.orderNo}`
      );
    },
    beforeCloseWriteComment(done) {
      if (!done) {
        done = () => {
          this.reviewDialogToNormalVisible = false;
        };
      }

      if (this.commentIntention) {
        this.$confirm({
          content: '退出將放棄本次評價，確認退出嗎？',
          confirmButtonText: '確認退出',
          cancelButtonText: '再想想',
          closeOnClickModal: false,
          closeOnPressEscape: false,
        }).then(done);
      } else {
        done();
      }
    },
    getCommentTagList() {
      if (!this.tagsMap) {
        getCommentTags().then(({ data }) => {
          this.tagsMap = data;
        });
      }
    },
    toggleCommentTag(tag) {
      if (!tag) {
        this.customInputTextareaVisible = !this.customInputTextareaVisible;

        return;
      }

      const index = this.checkedTags.findIndex((item) => item.tag === tag.tag);

      if (index > -1) {
        this.checkedTags.splice(index, 1);
      } else {
        this.checkedTags.push(tag);
      }
    },
    validateTextareaLen({ target }) {
      const { value } = target;

      if (value.length > 200) {
        this.customInputTextareaText = value.slice(0, 200);
      }
    },
    submitComment() {
      if (this.isSubmitingComment) return;

      const {
        orderInfo,
        commentIntention,
        checkedTags,
        customInputTextareaText,
      } = this;

      this.isSubmitingComment = true;

      createCommentToNormal({
        orderNo: orderInfo.orderNo,
        content: customInputTextareaText,
        tag: checkedTags.length
          ? checkedTags.map((t) => t.tag).join(',')
          : null,
        tagKind: commentIntention,
      })
        .then(() => {
          this.isSubmitingComment = false;

          this.$message.success('評價成功');

          this.reviewDialogToNormalVisible = false;

          this.orderInfo.playerCommentStatus = 'BuyerCommented';
        })
        .catch((err) => {
          this.isSubmitingComment = false;

          if (err.code === 624) {
            this.$message.error('您輸入的內容可能包含敏感詞彙，請重新輸入');
          }
        });
    },
    /**
     * @description: 再來一單
     * @param {Object} order 訂單信息
     */
    rePay(orderInfo) {
      const skill = orderInfo.playerSkillId;
      const count = orderInfo.count;
      this.$util.openWindow(`/order/check/${skill}/${count}?reorder=true`);
    },
    /**
     * @description: 取消未支付的订单
     */
    cancelPaying() {
      this.orderCancelShow = true;
    },
    /**
     * @description: b端申請退款
     */
    async refoundOrder() {
      let refoundConfirm = await this.$confirm(
        {
          content: '申請退款前請確保您已經跟用戶溝通過，或者有用戶違規證據。若無故取消被檢舉後可能導致您的技能被下架',
          confirmButtonText: '再想想',
          cancelButtonText: '繼續申請退款',
          showClose: false,
        }
      )
        .then(() => {
          return false;
        })
        .catch(() => {
          return true;
        });
      if (!refoundConfirm) return;
      this.handleRoundExplain('borderRound');
      this.corderRoundVisible = true;
    },
    refoundDetail() {
      if (this.type == 'c') {
        this.handleRoundExplain('orderRoundDetail');
        this.corderRoundVisible = true;
      } else {
        this.handleRoundExplain('borderRoundDetail');
        this.corderRoundVisible = true;
      }
    },
    tagsClick(item) {
      const { id } = item
      const $index = this.choiceTags.indexOf(id)
      if ($index === -1) {
        if (this.choiceTags.length === 3) return
        this.choiceTags.push(id)
      } else {
        this.choiceTags.splice($index, 1)
      }
      item.choose = !item.choose
    },
  },
};
</script>

<style lang="scss">
.controversy-dialog,
.write-review-dialog,
.write-controversy-dialog,
.reject-controversy-dialog,
.check-review-dialog > .el-dialog {
  box-shadow: none !important;
  .el-dialog__body {
    padding: 0 18px !important;
    .el-textarea__inner {
      border: 1px solid #dcdfe6;
      border-radius: 4px;
    }
  }
  .el-dialog__footer {
    padding-top: 10px;
    .is-disabled {
      color: #fff !important;
      background-color: #febfdb !important;
    }
  }
}
.write-review-dialog /deep/ .el-dialog {
  margin: 0 !important;
  border-radius: 14px !important;
  // height: 170px !important;
  position: fixed;
  transition: all 0.2s;
  overflow: hidden;
  .el-dialog__body {
    padding-bottom: 0 !important;
    .no-score {
      width: 100%;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
      color: #999999;
      margin-top: 8px;
    }
  }
  .el-dialog__footer {
    padding-top: 0px;
    padding-bottom: 28px;
    button {
      width: 100%;
      height: 44px;
      border-radius: 36px;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      &:disabled {
        opacity: 0.25;
      }
      @include button-yellow;
    }
  }
}
.select-star /deep/ .el-dialog {
  .el-dialog__footer {
    padding-top: 20px;
  }
}
.fix-comment {
  width: 76px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .edit-icon {
    font-size: 16px;
  }
  font-size: 14px;
  line-height: 20px;
  color: #666666;
}
.el-message-box__status {
  display: none;
}
.el-message-box__message {
  padding: 0 !important;
}
.write-review-dialog /deep/ .el-dialog {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
<style lang="scss" scoped>
.tags-wrap {
  padding: 16px 0 0;
  color: $color-gray-3;
  font-size: 12px;
  .title {
    height: 16px;
    font-weight: 500;
  }
  ul {
    @include flex(flex-start);
    flex-wrap: wrap;
    li {
      @include flex;
      margin: 8px 8px 0 0;
      height: 24px;
      padding: 0 9px;
      border: 1px solid #E8EAEE;
      border-radius: 24px;
      cursor: pointer;
      &.active {
        color: #fff;
        background-color: $color-gray-3;
        border: 1PX solid #8C94AA;
      }
    }
  }
}
.comment-score {
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: $color-yellow;
  margin-top: 7px;
}
.card-hide-right {
  height: 166px;
  padding-top: 30px;
  display: flex;
  box-sizing: border-box;
  width: 600px;
  align-items: center;
  .activeBack {
    background: linear-gradient(
      270deg,
      rgba(250, 0, 110, 0.5) 4.49%,
      rgba(250, 0, 110, 0.07) 100%
    );
  }
  .sleepBack {
    background: linear-gradient(
      270deg,
      rgba(166, 166, 166, 0.5) 4.49%,
      rgba(166, 166, 166, 0.07) 100%
    );
  }
  .step {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 58px;
    height: 136px;
    .step-title {
      margin-bottom: 12px !important;
      color: #999999;
    }
    img {
      margin-bottom: 12px !important;
    }
    p {
      text-align: center;
      color: #999999;
      white-space: nowrap;
      height: 20px;
      line-height: 20px;
    }
  }
  .step-line {
    width: 72px;
    position: relative;
    bottom: 10px;
    height: 6px;
  }
}
.production-info {
  display: none;
}
.check-review-dialog {
  .comment-rate {
    width: 100%;
    margin-bottom: 20px;
    height: 60px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    p {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 16px;
      text-align: right;
      color: $color-yellow;
    }
  }
  .star-wrap {
    margin-right: 20px;
  }
}
.anonymous {
  overflow: hidden;
  margin-top: 32px;
  > div {
    width: 100%;
    @include flex(flex-end);
    float: left;
    padding: 5px 0;
  }
  img {
    width: 15px;
    height: 15px;
  }
  span {
    margin-left: 8px;
    color: #666;
    font-size: 12px;
  }
}
.review-dialog-header {
  width: 100%;
  height: 60px;
  align-items: center;
  display: flex;
  justify-content: space-between;
  .stars {
    display: flex;
    justify-content: center;
    width: 100%;
  }
  .star-item {
    display: inline-block;
    width: 40px;
    height: 40px;
    margin: 0 4px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .star-icon {
    font-size: 40px;
    color: $color-gray-3;
    &.checked {
      color: $color-yellow;
    }
  }
}
.first-star-tips {
  height: 52px;
  position: relative;
  & > div {
    position: absolute;
    top: 0;
    right: -18px;
    left: -18px;
    bottom: 0;
    padding: 8px 18px;
    background: rgba(254, 127, 56, 0.08);
    text-align: left;
    font-size: 12px;
    line-height: 18px;
    color: $color-gray-1;
    span {
      color: $color-orange;
    }
  }
}
.star-tips {
  font-size: 14px;
  line-height: 20px;
  color: #999999;
  margin: 15px 0 10px;
}
.comment-textarea {
  transition: all 0.2s;
  height: 44px;
  margin-top: 32px;
  padding: 12px;
  position: relative;
  border: 1px solid #dcdfe6;
  border-radius: 8px;
  background: rgba(240, 240, 240, 0.5);
  .text-count {
    display: none;
  }
  .textarea /deep/ textarea {
    height: 20px;
    padding: 0;
    border: none;
    background: transparent;
    caret-color: $color-yellow;
  }
}
.heighter {
  .comment-textarea {
    height: 104px;
    padding: 12px 12px 32px;
    .text-count {
      display: block;
      position: absolute;
      bottom: 8px;
      right: 12px;
      font-weight: 500;
      font-size: 12px;
      line-height: 16px;
      color: #afafaf;
    }
    .textarea /deep/ textarea {
      height: 60px;
    }
  }
}
.controversy-dialog {
  width: 418px;
  margin: 0 auto;
  .controversy-top {
    width: 100%;
    display: flex;
    box-sizing: border-box;
    height: 20px;
    padding: 0 15px;
    .top-point {
      width: 15px;
      height: 15px;
      position: relative;
      right: 2px;
      margin-right: 20px;
      border-radius: 100%;
      background: $color-yellow;
      // box-shadow: 0px 1px 4px rgba(250, 0, 110, 0.345908);
    }
  }
  .controversy-middle {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    align-items: flex-start;
    margin: 0 20px 10px 20px;
    padding: 27px;
    border-left: 1px dashed gray;
  }
  .controversy-bottom {
    width: 100%;
    display: flex;
    padding: 0 17px;
    box-sizing: border-box;
    align-items: center;
    .bottom-point {
      width: 7px;
      margin-right: 25px;
      height: 7px;
      border-radius: 100%;
      background: gray;
    }
  }
}
.c-order-card {
  position: relative;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  width: 100%;
  border-radius: 6px;
  margin-top: 20px;
  background: #FFFFFF;
  border: 1px solid #E8EAEE;
  border-radius: 4px;
  padding: 0 20px;
  color: $color-gray-3;
  &.has-tag {
    padding-top: 22px;
  }
  .color-gray {
    color: #666666;
  }
  .color-red {
    color: $color-yellow;
  }
  .border-bottom {
    border-bottom: 1px solid #e0e0e0;
  }
  .card-header {
    width: 100%;
    color: white;
    height: 43px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: $color-gray-3;
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #F1F4F6;
    .card-id {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .to-chat {
        cursor: pointer;
      }
      p {
        word-break: break-all;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .order-id-title {
        margin-left: 7px;
      }
      .order-id {
        word-break: break-all;
        text-overflow: ellipsis;
        overflow: hidden;
        margin-left: 20px;
      }
      div {
        margin-left: 52px;
      }
    }
    .card-time {
      height: 40px;
      line-height: 20px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      cursor: pointer;
      img {
        width: 17px;
        height: 18px;
        position: relative;
        bottom: 1px;
      }
    }
  }
  .card-msg {
    width: 100%;
    align-items: center;
    display: flex;
    padding: 16px 0;
    .user-avatar-wrap {
      width: 72px;
      height: 72px;
      border-radius: 4px;
      cursor: pointer;
      overflow: hidden;
      .avatar {
        border-radius: 4px;
        /deep/ .avatar-wrap {
          border-radius: 4px;
          .img {
            border-radius: 4px;
          }
        }
      }
    }
    .order-info {
      display: flex;
      flex: 1;
      justify-content: space-between;
      align-items: center;
      margin-left: 56px;
      cursor: pointer;
      box-sizing: border-box;
      .order-msg {
        display: flex;
        flex-direction: column;
        justify-content: center;
        font-style: normal;
        width: 160px;
        p {
          line-height: 24px;
          font-size: 16px;
          margin: 0;
          font-weight: normal;
          width: 100%;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          color: $color-gray-3;
          &:first-child {
            font-weight: 500;
            cursor: pointer;
            color: $color-gray-1;
            margin-bottom: 4px;
          }
        }
      }
    }
    .order-unit {
      width: 100px;
      color: #666666;
      p {
        text-align: center;
      }
    }
    .order-num {
      color: #666666;
      width: 86px;
      p {
        text-align: center;
      }
    }
    .order-price {
      color: $color-gray-1;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 20px;
      text-align: center;
      width: 174px;
      display: flex;
      flex-direction: column;
      align-items: center;
      div {
        margin: 5px 0;
      }
    }
    .order-status {
      width: 160px;
      p {
        text-align: center;
        color: $color-gray-3;
      }

      &.color-light p {
        color: $color-orange;
      }
      .order-countDown {
        margin-top: 6px;
        color: $color-orange;
      }
    }
    .order-operation-auto {
      display: none;
    }
    .order-operation {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 80px;
      .operation-btn {
        cursor: pointer;
        width: 80px;
        height: 32px;
        font-weight: normal;
        border-radius: 50px;
        border: 1px solid $color-split;
        font-style: normal;
        @include flex;
        font-size: 13px;
        color: $color-gray-2;
        cursor: pointer;
        &:not(:first-child) {
          margin-top: 8px;
        }
      }
      .re-pay {
        border: none;
        color: $color-gray-1;
        background: $color-yellow;
      }
      .red-btn {
        border: none;
        color: $color-gray-1;
        background: $color-yellow;
      }
    }
  }
  .card-hide {
    height: 210px;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    .card-hide-left {
      width: 166px;
      height: 136px;
      color: #333333;
      height: 20px;
      line-height: 20px;
      padding-top: 30px;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      padding-left: 20px;
    }
    p {
      margin: 0;
    }
  }
}
.controversy-dialog-auto {
  display: none;
}
.controversy-dialog {
  z-index: 2039 !important;
}

.comments-dialog,
.write-comment-to-normal {
  .dialog-wrap {
    position: absolute;
    top: 50vh;
    left: 50%;
    width: 418px;
    height: auto;
    background: white;
    overflow: hidden;
    border-radius: 8px;
    transform: translate3d(-50%, -50%, 0);
  }

  .page-title {
    position: relative;
    @include flex(space-between);
    height: 60px;
    color: #333;
    background: white;
    padding: 0 18px;
    border-bottom: 1px solid #ececec;

    h3 {
      font-size: 18px;
      line-height: 18px;
      font-weight: 500;
      color: #000;
    }

    .close-icon {
      position: absolute;
      top: 50%;
      right: 18px;
      font-size: 16px;
      transform: translateY(-50%);
      cursor: pointer;
    }
  }

  .comment-box {
    @include flex(flex-start, flex-start);
    padding: 22px 18px 20px 0;
    margin-left: 18px;

    &:nth-child(2) {
      border-top: 1px solid #ececec;
    }

    .avatar {
      flex-shrink: 0;
      width: 30px;
      height: 30px;
      border-radius: 100%;
    }

    .comment-detail {
      flex: 1;
      margin-left: 8px;
    }

    .title {
      @include flex(flex-start);

      p,
      span {
        font-size: 14px;
        line-height: 20px;
      }

      p {
        font-weight: 500;
        color: #000;
        margin-right: 5px;
      }
    }

    .comment-time {
      color: #999;
      font-size: 14px;
      line-height: 20px;
    }

    .comment-star {
      @include flex(flex-start);
      color: $color-yellow;
      font-size: 16px;
      margin: 12px 0;

      p {
        margin-left: 5px;
      }
    }

    .comment-tag {
      margin-top: 12px;
      color: #333;
      font-size: 14px;
      line-height: 20px;
      font-weight: normal;

      span:not(:last-child) {
        margin-right: 5px;
      }
    }

    .comment-like {
      @include flex(flex-start);
      margin: 12px 0;

      img {
        width: 40px;
        height: 26px;
        margin-right: 6px;
      }

      p {
        color: #f28b1b;
        font-weight: 500;
        font-size: 16px;
      }
    }

    .comment-content {
      // margin-top: 12px;
      line-height: 20px;
      color: #333;
    }

    .content-tags {
      margin-top: 10px;
    }
  }

  .page-footer {
    @include flex(flex-end);
    padding: 10px 18px 20px 0;

    button {
      width: 100px;
      height: 40px;
      font-size: 14px;
      font-weight: 500;
      border-radius: 36px;
      @include button-yellow;
    }
  }
}

.write-comment-to-normal {
  .page-main {
    padding: 20px 18px;
    background: white;

    .title {
      @include flex(space-between);

      h3 {
        font-size: 18px;
        font-weight: 500;
        line-height: 20px;
        color: #333333;
      }

      span {
        font-size: 14px;
        line-height: 20px;
        color: #666;
      }
    }

    .order-info {
      @include flex(flex-start);
      margin-top: 16px;
    }

    .player-avatar {
      width: 40px;
      height: 40px;
      border-radius: 100%;
    }

    .order-player-info {
      font-size: 14px;
      line-height: 14px;
      margin-left: 8px;
      color: #333;
      text-align: left;

      p:nth-child(2) {
        color: #999;
        margin-top: 6px;
      }

      span:nth-child(2) {
        margin-left: 5px;
      }
    }

    .order-comment {
      margin-top: 24px;

      .checked {
        background: #fdf8eb !important;
        color: #f28b1b !important;
      }

      .result {
        @include flex(center);

        div {
          @include flex();
          width: 186px;
          height: 44px;
          border-radius: 6px;
          background: #f5f5f5;
          transition: all 0.2s;
          cursor: pointer;

          &:nth-child(1) {
            margin-right: 10px;
          }
        }

        span {
          font-size: 16px;
          font-weight: 500;
        }

        img {
          width: 40px;
          height: 26px;
          margin-right: 4px;
        }
      }

      .tags {
        margin-top: 24px;

        p {
          font-size: 14px;
          line-height: 20px;
          text-align: left;
        }
      }

      .tag-list {
        @include flex(flex-start);
        flex-wrap: wrap;
        font-size: 14px;
        line-height: 14px;
        margin-top: 24px;

        div {
          flex-shrink: 0;
          flex-grow: 0;
          @include flex();
          width: 91px;
          height: 32px;
          color: #858687;
          line-height: 32px;
          border-radius: 16px;
          background: #f5f5f6;
          margin-bottom: 8px;
          cursor: pointer;

          img {
            width: 12px;
            height: 12px;
            vertical-align: middle;
            margin-right: 3px;
          }

          &:not(:nth-child(4n)) {
            margin-right: 6px;
          }
        }
      }

      textarea {
        display: block;
        width: 382px;
        height: 120px;
        font-size: 16px;
        line-height: 20px;
        border-radius: 10px;
        padding: 10px;
        background: #f6f6f7;
        border: 1px solid #e2e3e6;
        resize: none;
        margin: 24px auto 0;

        &::-webkit-input-placeholder {
          color: #a9a9a9;
        }
      }
    }
  }

  .page-footer {
    @include flex(space-between);
    margin-top: 30px;
    padding: 0 18px 20px;
    text-align: center;

    p {
      color: #999;
      font-size: 14px;
    }

    button {
      width: 100px;
      height: 40px;
      font-size: 14px;
      color: white;
      background: $color-yellow;
      border-radius: 36px;

      &[disabled] {
        background: #febfdb !important;
        color: white !important;
      }
    }
  }
}
.give-away-info {
  color: $color-yellow;
}
.repay-tag {
  position: absolute;
  padding: 5px;
  font-size: 12px;
  line-height: 1;
  top: 0;
  left: 0;
  background: #c7e8fb;
  color: #333;
  border-radius: 0 0 4px 0;
}
</style>
